import { c as _c } from "react/compiler-runtime";
import { useQuery } from "react-query";
import { useApi } from "./useApi";
interface Actor {
  id: number;
  login: string;
  avatar_url: string;
  type: string;
}
export function useActors(org) {
  const $ = _c(7);
  const api = useApi();
  let t0;
  if ($[0] !== org) {
    t0 = ["actors", org];
    $[0] = org;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== api || $[3] !== org) {
    t1 = async () => {
      const response = await api.get(`user/github/orgs/${org}/metrics/actions/actors`);
      const actorMap = new Map();
      response.data.actors.forEach(actor => {
        if (actor.avatar_url) {
          actorMap.set(actor.login, actor.avatar_url);
        }
      });
      return actorMap;
    };
    $[2] = api;
    $[3] = org;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !!org;
  let t3;
  if ($[5] !== t2) {
    t3 = {
      enabled: t2,
      staleTime: 86400000,
      cacheTime: 86400000
    };
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t0, t1, t3);
}